module.exports = __webpack_public_path__ + "0025bb7a05eed3c78d8b98c353fdecb8.svg";